import React from 'react';

import { Text } from '@mantine/core';

import { buildRenewalSummary } from './renewalSummaryText';
import { AttendanceRuleFormValue } from '../types';

interface IRenewalSummaryProps {
  attendanceRules: AttendanceRuleFormValue[];
  lengthAmount: number | null;
  lengthPeriod: string | null;
  autoRenews: boolean;
}

/** States when a time-or-credit-based package renews or ends, updating as the form changes. */
const RenewalSummary = (props: IRenewalSummaryProps): JSX.Element | null => {
  const summary = buildRenewalSummary(props);
  if (!summary) return null;

  return (
    <Text size='sm' color='dimmed' data-cy='renewalSummary'>
      {summary}
    </Text>
  );
};

export default RenewalSummary;
